"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reactProvider = require("@trycourier/react-provider");

var _clientGraphql = require("@trycourier/client-graphql");

var _init = require("../actions/init");

var _toggleInbox2 = require("../actions/toggle-inbox");

var _setView2 = require("../actions/set-view");

var _markMessageRead3 = require("../actions/mark-message-read");

var _markAllRead = require("./actions/mark-all-read");

var _markMessageUnread3 = require("../actions/mark-message-unread");

var _markMessageArchived3 = require("../actions/mark-message-archived");

var _newMessage2 = require("./actions/new-message");

var _resetLastFetched2 = require("../actions/reset-last-fetched");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useElementalInboxActions = function useElementalInboxActions() {
  var _useCourier = (0, _reactProvider.useCourier)(),
      apiUrl = _useCourier.apiUrl,
      authorization = _useCourier.authorization,
      clientSourceId = _useCourier.clientSourceId,
      clientKey = _useCourier.clientKey,
      dispatch = _useCourier.dispatch,
      inbox = _useCourier.inbox,
      transport = _useCourier.transport,
      userId = _useCourier.userId,
      userSignature = _useCourier.userSignature;

  var courierClient = (0, _clientGraphql.createCourierClient)({
    authorization: authorization,
    apiUrl: apiUrl !== null && apiUrl !== void 0 ? apiUrl : "https://fxw3r7gdm9.execute-api.us-east-1.amazonaws.com/production/q",
    clientKey: clientKey,
    clientSourceId: clientSourceId,
    userId: userId,
    userSignature: userSignature
  });
  var inboxClient = (0, _clientGraphql.Inbox)({
    client: courierClient
  });
  return {
    init: function init(payload) {
      dispatch((0, _init.initInbox)(payload));

      if (payload.isOpen) {
        dispatch({
          type: "inbox/FETCH_MESSAGES",
          payload: function payload() {
            return inboxClient.getMessages();
          }
        });
      }
    },
    resetLastFetched: function resetLastFetched() {
      dispatch((0, _resetLastFetched2.resetLastFetched)());
      dispatch({
        type: "inbox/FETCH_UNREAD_MESSAGE_COUNT",
        payload: function payload() {
          return inboxClient.getInboxCount({
            status: "unread"
          });
        }
      });
    },
    toggleInbox: function toggleInbox(isOpen) {
      dispatch((0, _toggleInbox2.toggleInbox)(isOpen));
    },
    setView: function setView(view) {
      dispatch((0, _setView2.setView)(view));
    },
    fetchMessages: function fetchMessages(_payload) {
      var params = _objectSpread({
        from: inbox === null || inbox === void 0 ? void 0 : inbox.from
      }, _payload === null || _payload === void 0 ? void 0 : _payload.params);

      dispatch({
        type: "inbox/FETCH_MESSAGES",
        payload: function payload() {
          return inboxClient.getMessages(params, _payload === null || _payload === void 0 ? void 0 : _payload.after);
        },
        meta: _payload
      });
    },
    getUnreadMessageCount: function getUnreadMessageCount() {
      dispatch({
        type: "inbox/FETCH_UNREAD_MESSAGE_COUNT",
        payload: function payload() {
          return inboxClient.getInboxCount({
            status: "unread"
          });
        }
      });
    },
    markMessageRead: function () {
      var _markMessageRead2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(messageId, fromWSEvent) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch((0, _markMessageRead3.markMessageRead)(messageId));

                if (!fromWSEvent) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                _context.next = 5;
                return inboxClient.markRead(messageId);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function markMessageRead(_x, _x2) {
        return _markMessageRead2.apply(this, arguments);
      }

      return markMessageRead;
    }(),
    markAllAsRead: function () {
      var _markAllAsRead = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(fromWSEvent) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dispatch((0, _markAllRead.markAllRead)());

                if (!fromWSEvent) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                _context2.next = 5;
                return inboxClient.markAllRead();

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function markAllAsRead(_x3) {
        return _markAllAsRead.apply(this, arguments);
      }

      return markAllAsRead;
    }(),
    markMessageUnread: function () {
      var _markMessageUnread2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(messageId, fromWSEvent) {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dispatch((0, _markMessageUnread3.markMessageUnread)(messageId));

                if (!fromWSEvent) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:
                _context3.next = 5;
                return inboxClient.markUnread(messageId);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function markMessageUnread(_x4, _x5) {
        return _markMessageUnread2.apply(this, arguments);
      }

      return markMessageUnread;
    }(),
    markMessageArchived: function () {
      var _markMessageArchived2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(messageId, fromWSEvent) {
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dispatch((0, _markMessageArchived3.markMessageArchived)(messageId));

                if (!fromWSEvent) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return");

              case 3:
                _context4.next = 5;
                return inboxClient.markArchive(messageId);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function markMessageArchived(_x6, _x7) {
        return _markMessageArchived2.apply(this, arguments);
      }

      return markMessageArchived;
    }(),
    renewSession: function () {
      var _renewSession = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(token) {
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (transport instanceof _reactProvider.CourierTransport) {
                  transport.renewSession(token);
                }

                dispatch({
                  type: "root/UPDATE_AUTH_TOKEN",
                  payload: token
                });

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function renewSession(_x8) {
        return _renewSession.apply(this, arguments);
      }

      return renewSession;
    }(),
    newMessage: function newMessage(message) {
      if (!message.messageId) {
        return;
      }

      dispatch((0, _newMessage2.newMessage)(message));
    }
  };
};

var _default = useElementalInboxActions;
exports["default"] = _default;